import { render } from "./AreaSelect.vue?vue&type=template&id=1aa1dbf1&ts=true"
import script from "./AreaSelect.vue?vue&type=script&lang=ts"
export * from "./AreaSelect.vue?vue&type=script&lang=ts"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__